import { ModuleWithProviders, NgModule } from '@angular/core';
import { ComboKvPipe } from './comboKv.pipe';
import { AuditTranslatePipe } from './audit-translate.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';

@NgModule({
    imports: [],
    declarations: [
    ComboKvPipe,
    AuditTranslatePipe,
    SafeHtmlPipe
  ],
    exports: [ComboKvPipe, AuditTranslatePipe, SafeHtmlPipe]
})

export class SharedPipeModule {

    static forRoot(): ModuleWithProviders<SharedPipeModule> {
    return {
        ngModule: SharedPipeModule,
        providers: [],
    };
}
}
